import { ProgramSubscriptionStatus } from "@/modules/programs/types/programTypes"
import { CouponDtoSchema } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PauseDtoSchema } from "@modules/common/pauseObject/gateway/pauseApiDto"
import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { ProgramTrialSubscriptionDtoSchema } from "@modules/common/trialSubscription/gateway/trialSubscriptionApiDto"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { LightInvoiceDtoSchema } from "@modules/finances/gateway/lightInvoiceDto"
import { PaymentErrorDtoSchema } from "@modules/finances/types/stripeErrorTypes"
import { ProgramBundleDtoSchema } from "@modules/programBundle/api/programBundleDto"
import { LightPromoCodeDtoSchema } from "@modules/promoCode/gateway/promoCodeDto"
import { z } from "zod"

export const ProgramBundleSubscriberDtoSchema = z
  .object({
    id: z.string(),
    username: z.string(),
    firstname: z.string(),
    lastname: z.string(),
    avatar: HUImageDtoSchema.nullable(),
    nationality: z.string().nullable(),
    email: z.string().nullable(),
    subscriptionStatus: z.enum(ProgramSubscriptionStatus),
    subscriptionId: z.string().nullable(),
    programBundleSubscriptionId: z.string(),
    periodEndDate: z.string().nullable(),
    subscriptionDate: z.string(),
    paidPrice: PriceObjectDtoSchema.nullable(),
    referencePrice: PriceObjectDtoSchema.nullable(),
    usedPromoCode: LightPromoCodeDtoSchema.nullable(),
    coupon: CouponDtoSchema.nullable(),
    pause: PauseDtoSchema.nullable(),
    trial: ProgramTrialSubscriptionDtoSchema.nullable(),
    internalNote: z.string().nullable(),
    programBundle: ProgramBundleDtoSchema,
    error: PaymentErrorDtoSchema.nullable(),
    lastInvoices: LightInvoiceDtoSchema.array().nullable(),
    nextPayment: PriceObjectDtoSchema.nullable(),
    nextPaymentDate: z.string().nullable(),
  })
  .meta({ id: "ProgramBundleSubscriberDtoSchema" })

export type ProgramBundleSubscriberDto = z.infer<typeof ProgramBundleSubscriberDtoSchema>
